import { all } from 'redux-saga/effects'
import { rootSaga as requestsSaga } from '../utils/requests-reducer/saga'
import { rootSaga as navbarSaga } from '../containers/navbar/saga'
import { rootSaga as homeSaga } from '../containers/home/saga'

export function* rootSaga() {
  yield all([requestsSaga(), navbarSaga(), homeSaga()])
}
